import { useContext } from 'react';
import { AuthManagerContext } from './AuthManagerContext';

export const useAuthManagerContext = () => {
  const context = useContext(AuthManagerContext);
  if (!context) {
    throw new Error(
      'useAuthManagerContext must be used within an AuthManagerProvider',
    );
  }
  return context;
};
